import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Parcel2Kg: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M105.864 80.601L206.833 62.48 149.136 34 48.166 51.753 105.865 80.6z" fill="#FDDE84" />
    <path opacity=".4" d="M81.084 68.026l100.969-17.753-9.616-4.808-101.34 18.123 9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l-57.697-28.848v-53.26l57.697 28.85z" fill="#C39000" />
    <path opacity=".4" d="M81.084 68.026v19.972l-9.987-5.178V63.588l9.987 4.438z" fill="#AA7B33" />
    <path d="M105.864 80.601v53.259l100.969-18.493V62.478L105.864 80.602z" fill="#FCCE09" />
    <path
      d="M221.5 92.3c0-2.5-6.2-4.6-13.7-4.6-7.5 0-13.7 2.1-13.7 4.6v28.8c0 2.5 6.2 4.6 13.7 4.6 7.5 0 13.7-2.1 13.7-4.6V92.3z"
      fill="#6D6D6D"
    />
    <path
      d="M221.5 121.1V92.3c0 1.1-1.2 2.2-3.3 3v28.8c2.1-.8 3.3-1.9 3.3-3zM207.7 96.9c-7.6 0-13.7-2.1-13.7-4.6v28.8c0 2.5 6.2 4.6 13.7 4.6h2.2V97c-.6-.1-1.4-.1-2.2-.1z"
      fill="#6D6D6D"
    />
    <path
      d="M207.7 96.9c7.566 0 13.7-2.06 13.7-4.6 0-2.54-6.134-4.6-13.7-4.6-7.566 0-13.7 2.06-13.7 4.6 0 2.54 6.134 4.6 13.7 4.6z"
      fill="#C8C8C8"
    />
    <path
      opacity=".05"
      d="M207.8 94.4c4.197 0 7.6-1.12 7.6-2.5s-3.403-2.5-7.6-2.5c-4.197 0-7.6 1.12-7.6 2.5s3.403 2.5 7.6 2.5z"
      fill="#000"
    />
    <path
      d="M210 92.1v-4.7c0-.4-1-.7-2.2-.7-1.2 0-2.2.3-2.2.7V92c0 .1.1.2.2.3.3.3 1.1.5 2 .5.7 0 1.3-.1 1.7-.3.1 0 .1 0 .2-.1h.1s.1 0 .1-.1l.1-.1v-.1z"
      fill="#555"
    />
    <path
      d="M215.4 82.5c0-1.4-3.4-2.5-7.6-2.5-4.2 0-7.6 1.1-7.6 2.5v4.3c0 1.4 3.4 2.5 7.6 2.5 4.2 0 7.6-1.1 7.6-2.5v-4.3z"
      fill="#6D6D6D"
    />
    <path
      opacity=".1"
      d="M215.4 82.5c0-1.4-3.4-2.5-7.6-2.5-4.2 0-7.6 1.1-7.6 2.5v4.3c0 1.4 3.4 2.5 7.6 2.5 4.2 0 7.6-1.1 7.6-2.5v-4.3z"
      fill="#fff"
    />
    <path
      d="M215.4 86.8v-4.3c0 .6-.7 1.2-1.8 1.6v4.3c1.1-.4 1.8-.9 1.8-1.6zM207.8 85c-4.2 0-7.6-1.1-7.6-2.5v4.3c0 1.4 3.4 2.5 7.6 2.5h1.2V85h-1.2z"
      fill="#6D6D6D"
    />
    <path
      d="M207.8 85c4.197 0 7.6-1.12 7.6-2.5s-3.403-2.5-7.6-2.5c-4.197 0-7.6 1.12-7.6 2.5s3.403 2.5 7.6 2.5z"
      fill="#C8C8C8"
    />
    <path
      d="M207.5 110.2v-1.9c1.3-1.2 1.9-1.8 3.2-3.2.3-.3.5-.5.6-.8.1-.2.2-.5.2-.7 0-.3-.1-.6-.3-.7-.2-.2-.5-.2-.8-.2-.4 0-.7.1-.9.3-.3.2-.5.4-.7.7-.6-.5-1-.8-1.6-1.4.4-.5.9-.8 1.4-1.1.5-.3 1.3-.5 2.1-.5 1.1-.1 1.9.1 2.5.5.6.4 1 1 1 2 0 .4-.1.8-.2 1.2-.2.4-.4.7-.6 1.1-.3.4-.6.8-1 1.2-.5.6-.8.9-1.3 1.4 1.4-.1 2-.2 3.4-.4v2.1c-2.8.4-4.2.5-7 .4zM205.4 118.9v-5.8c.7 0 1 .1 1.7.1v2.2h.4c.5-.9.8-1.3 1.3-2.2.8 0 1.2 0 2-.1-.7 1.2-1.1 1.8-1.8 2.9.8 1.2 1.2 1.7 2 2.8-.8.1-1.2.1-2.1.1-.6-.9-.9-1.3-1.4-2.3h-.3v2.3c-.7.1-1.1.1-1.8 0zM214 118.7c-.8.1-1.5 0-1.9-.4-.5-.4-.7-1.1-.7-2v-.5c0-.6.1-1.1.3-1.5.2-.4.5-.8 1-1.1.4-.3.9-.4 1.4-.5.9-.2 1.6-.1 2 .4-.4.5-.6.7-.9 1.2-.1-.1-.3-.2-.5-.2h-.6c-.4.1-.6.2-.8.5-.2.3-.2.7-.2 1.2v.4c0 .5.1.9.2 1.1.1.2.4.3.7.3.3-.1.5-.2.6-.4.1-.2.2-.5.2-.8-.4.1-.6.1-1 .2v-1.2c1-.2 1.6-.3 2.5-.6v1c0 .8-.2 1.5-.6 2-.3.4-.9.8-1.7.9z"
      fill="#D3D1D1"
    />
    <path opacity=".2" d="M218.2 124.1s0-.1 0 0V95.3c-2.1.9-4.8 1.4-8.3 1.6v28.7c3.6-.1 6.2-.6 8.3-1.5z" fill="#fff" />
  </SvgIcon>
)
